import script from "./BrowseDashboardsSlideover.vue?vue&type=script&setup=true&lang=js"
export * from "./BrowseDashboardsSlideover.vue?vue&type=script&setup=true&lang=js"

import "./BrowseDashboardsSlideover.vue?vue&type=style&index=0&id=3b23c93e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b23c93e"]])

export default __exports__